import { render } from "./PublicUserReportsView.vue?vue&type=template&id=fb2a82ba"
import script from "./PublicUserReportsView.vue?vue&type=script&lang=js"
export * from "./PublicUserReportsView.vue?vue&type=script&lang=js"

import "./PublicUserReportsView.vue?vue&type=style&index=0&id=fb2a82ba&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__